import { render, staticRenderFns } from "./PaginaScenariVendita.vue?vue&type=template&id=edc37f2a&"
import script from "./PaginaScenariVendita.vue?vue&type=script&lang=js&"
export * from "./PaginaScenariVendita.vue?vue&type=script&lang=js&"
import style0 from "./PaginaScenariVendita.vue?vue&type=style&index=0&id=edc37f2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports